import type { Record } from "~/tools/record";

// Map theme paths to CSS variables or direct values
const THEME_MAP = {
	// Colors - Blue
	"colors.blue.100": "#E6F7FF",
	"colors.blue.200": "#B9E7FF",
	"colors.blue.500": "#29A2FF",
	"colors.blue.600": "#008AFF",
	"colors.blue.700": "#006CD9",
	"colors.blue.800": "#0053B3",

	// Colors - Graphite
	"colors.graphite.100": "#F6F6F7",
	"colors.graphite.275": "#DBDDE0",
	"colors.graphite.300": "#CFD2D6",
	"colors.graphite.500": "#9FA5AD",
	"colors.graphite.600": "#878E98",
	"colors.graphite.700": "#707985",

	// Colors - Gray
	"colors.gray.100": "#FAFAFA",
	"colors.gray.200": "#F5F5F5",
	"colors.gray.300": "#F0F0F0",
	"colors.gray.400": "#D9D9D9",
	"colors.gray.500": "#BFBFBF",
	"colors.gray.600": "#8C8C8C",
	"colors.gray.800": "#434343",
	"colors.gray.900/90": "rgb(38 38 38 / 0.9)",

	// Colors - Green
	"colors.green.100": "#F0FFF0",
	"colors.green.375": "#AAE6AF",
	"colors.green.500": "#64D171",
	"colors.green.700": "#2B9E40",

	// Colors - Orange
	"colors.orange.100": "#FFF8EB",
	"colors.orange.400": "#FFBF70",
	"colors.orange.500": "#FFA647",
	"colors.orange.600": "#FF8A1E",

	// Colors - Pastel
	"colors.pastel.blue": "#80ABFF",
	"colors.pastel.green": "#A9E195",
	"colors.pastel.red": "#FA8B8C",

	// Colors - Pink
	"colors.pink.500": "#F783C5",
	"colors.pink.700": "#C43F93",

	// Colors - Purple
	"colors.purple.400": "#AC83F7",
	"colors.purple.500": "#8657EB",
	"colors.purple.600": "#653FC4",

	// Colors - Red
	"colors.red.100": "#FFF2F0",
	"colors.red.200": "#FFDDD9",
	"colors.red.400": "#F78783",
	"colors.red.500": "#EB5757",
	"colors.red.700": "#9E2B32",

	// Colors - Yellow
	"colors.yellow.500": "#FFCB47",

	// Colors - White/Black
	"colors.white": "#FFFFFF",

	// Colors - Graph
	"colors.graph-blue.20": "#1F78B4",
	"colors.graph-green.20": "#33A02C",
	"colors.graph-orange.20": "#FF7F00",
	"colors.graph-purple.20": "#6A3D9A",
	"colors.graph-red.20": "#E31A1C",

	// Font Family
	"fontFamily.text": "Roboto Flex Variable, Roboto, sans-serif",
	"fontFamily.mono": "Roboto Mono Variable, Monaco, monospace",

	// Spacing
	"spacing.2": "0.5rem",
	"spacing.4": "1rem",

	// Width
	"width.full": "100%",

	// Height
	"height.48": "12rem",
	"height.full": "100%",

	// Opacity
	"opacity.60": "0.6",
	"opacity.100": "1",

	// Cursor
	"cursor.pointer": "pointer",
	"cursor.wait": "wait",
} satisfies Record<string, string>;

/**
 * @deprecated Using only during transition to tailwind v4, then remove and use css variables.
 */
export function theme(path: keyof typeof THEME_MAP): string {
	return THEME_MAP[path];
}
